import { FC } from 'react';

interface CartStatusPromptProps {
  message: string;
  actionLabel: string;
  onAction: () => void;
}

export const CartStatusPrompt: FC<CartStatusPromptProps> = ({ message, actionLabel, onAction }) => (
  <div className="shopping-cart-status-prompt">
    <span className="h4-text shopping-cart-status-prompt__body">{message}</span>
    <button
      type="button"
      className="btn-inkBlue btn btn-secondary shopping-cart-status-prompt__button"
      onClick={onAction}
    >
      {actionLabel}
    </button>
  </div>
);
